<template>
  <div v-if="error" class="h-full">
    <div
      class="max-w-[50rem] flex flex-col justify-center mx-auto w-full h-full"
    >
      <header class="flex justify-center z-50 w-full py-4">
        <nav class="px-4 sm:px-6 lg:px-8" aria-label="Global">
          <a
            class="flex-none text-xl font-semibold sm:text-3xl dark:text-white"
            href="#"
            aria-label="Moonshot Health"
            >Moonshot Health</a
          >
        </nav>
      </header>

      <div>
        <div class="text-center py-10 px-4 sm:px-6 lg:px-8">
          <h1
            class="block text-7xl font-bold text-gray-800 sm:text-9xl dark:text-white"
          >
            {{ $t('error_500_message_line_1') }}
          </h1>
          <p class="text-gray-600 dark:text-gray-400">
            {{ $t('error_500_message_line_2') }}
          </p>
          <div
            class="mt-5 flex flex-col justify-center items-center gap-2 sm:flex-row sm:gap-3"
          >
            <a
              href="/"
              class="w-full sm:w-auto inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold text-blue-500 hover:text-blue-700 focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm py-3 px-4 dark:ring-offset-slate-900"
            >
              <svg
                class="w-2.5 h-2.5"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M11.2792 1.64001L5.63273 7.28646C5.43747 7.48172 5.43747 7.79831 5.63273 7.99357L11.2792 13.64"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              {{ t('error_500_back_button') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="h-full">
    <suspense>
      <router-view />
    </suspense>
  </div>
</template>

<script setup>
import moment from 'moment';
import { useI18n } from 'vue-i18n';
import { computed, ref, onErrorCaptured } from 'vue';
import { useConfigStore } from './store';

const { locale, t } = useI18n({ useScope: 'global' });
const lang = computed(() => useConfigStore().currentLang);
locale.value = lang.value.id;
moment.locale(locale.value);

// Properties
const error = ref(false);

// Events
// In development we want to error and stacktrace to show in the browser.
if (process.env.VUE_APP_DEBUG_ERROR !== 'true') {
  onErrorCaptured(() => {
    error.value = true;
    return false;
  });
}
</script>
